module.exports = __webpack_public_path__ + "static/media/aboutus.d78011d7.svg";